import {  Routes, Route, useLocation } from "react-router";
import React, { Suspense, lazy, useEffect } from 'react';
import Loader from "./components/Loader";

const LandingPage = lazy(() => import('./pages/LandingPage'));
const About = lazy(() => import('./pages/About'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Services = lazy(() => import('./pages/Services'));
const Gallery = lazy(() => import('./pages/Gallery'));



const AppRoutes = () => {
    const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [pathname]);
  
    return(
        <Suspense fallback={<Loader />}>
        <Routes>
            <Route path="/" element={<LandingPage/>} />
            <Route path="/about" element={<About/>}/>
            <Route path="/work" element={<Gallery/>}/>
            <Route path="/services" element={<Services/>}/>
            <Route path="/contact-us" element={<ContactUs/>}/>
            
        </Routes>
        </Suspense>
    )
}

export default AppRoutes;